import { useCount } from "../store";
function SomeComponentDemoStoreStateManagementChild() {
  const count = useCount();
  return <div>Child div with value count: {count}</div>;
}

export default SomeComponentDemoStoreStateManagementChild;
